<div class="header">
  <div class="header__button">
    <ng-container *ngIf="options.buttons?.left as leftButton">
      <ng-container *ngxPermissionsOnly="leftButton.permissions ?? []">
        <button
          *ngIf="leftButton.visible()"
          tuiButton
          type="button"
          appearance="icon"
          [iconStart]="leftButton.icon || ''"
          size="s"
          [tuiHint]="leftButton.label"
          (click)="leftButton?.action()"
        >
          {{ leftButton.label }}
        </button>
      </ng-container>
    </ng-container>
  </div>

  <div class="header__title">{{ options.title }}</div>

  <div class="header__button">
    <ng-container *ngIf="options.buttons?.right as rightButton">
      <ng-container *ngxPermissionsOnly="rightButton.permissions ?? []">
        <button
          *ngIf="rightButton.visible()"
          tuiButton
          type="button"
          appearance="icon"
          [iconStart]="rightButton.icon || ''"
          size="s"
          [tuiHint]="rightButton.label"
          (click)="rightButton.action()"
        >
          {{ rightButton.label }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
